import classNames from "classnames";
import ImageCell from "./ImageCell";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";
import { useNewsArticle } from "../../hooks/NewsHooks";
import GridCell, { GridCellCommonProps } from "./GridCell";
import { storiesBaseUrl } from "../../config/urls";
import { Suspense } from "react";
import { Spinner } from "reactstrap";
import Color from "color";
import "./style.scss";

const NewsCellInner = ({
  id,
  className,
  cellSize = "1x1",
  news_id,
  theme = "black",
  requiresFeature,
  ...unhandledProps
}: GridCellCommonProps & { news_id: number }) => {
  const news = useNewsArticle(news_id);
  const bkgColor = news?.image.colors?.[0]
    ? Color(news?.image.colors?.[0]).darken(0.3).saturate(0.5)
    : Color("#333");
  const textBkgColor = news?.image.colors?.[0]
    ? bkgColor.fade(0.3)
    : Color("#000").fade(0.7);

  return news ? (
    <ImageCell
      id={id}
      className={classNames("news-cell", className)}
      cellSize={cellSize}
      theme={theme}
      bkgColor={bkgColor.hex()}
      textBkgColor={textBkgColor.toString()}
      requiresFeature={requiresFeature}
      heading={news.heading}
      text={news.summary || ""}
      image={news.image}
      url={storiesBaseUrl + "/" + news.url}
      {...unhandledProps}
    />
  ) : null;
};

const NewsCell = ({
  id,
  className,
  cellSize = "1x1",
  news_id,
  theme = "black",
  requiresFeature,
  ...unhandledProps
}: GridCellCommonProps & { news_id: number }) => {
  const features = useSiteFeatures();

  return !requiresFeature || features.hasFeature(requiresFeature) ? (
    <Suspense
      fallback={
        <GridCell
          id={id}
          className={classNames("news-cell", className)}
          cellSize={cellSize}
          theme={theme}
        >
          <Spinner />
        </GridCell>
      }
    >
      <NewsCellInner
        id={id}
        className={classNames("news-cell", className)}
        cellSize={cellSize}
        theme={theme}
        news_id={news_id}
        requiresFeature={requiresFeature}
        {...unhandledProps}
      />
    </Suspense>
  ) : null;
};

export default NewsCell;
